import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ResetPasswordService } from './reset-password.service';

@Injectable()
export class ResetPasswordResolver implements Resolve<Observable<any>> {
  constructor(private resetPasswordService: ResetPasswordService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    // const token = route.queryParams['recoveryToken'];

    // if (!token) return of(null);

    // return this.resetPasswordService.fetchStateToken(token).pipe(
    //   map(res => ({ stateToken: res.stateToken })),
    //   catchError(err => {
    //     return of({ err });
    //   }),
    // );
    return of(null);
  }
}
